import { render, staticRenderFns } from "./LoaderRound.vue?vue&type=template&id=318835cd&scoped=true&"
import script from "./LoaderRound.vue?vue&type=script&lang=js&"
export * from "./LoaderRound.vue?vue&type=script&lang=js&"
import style0 from "./LoaderRound.vue?vue&type=style&index=0&id=318835cd&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "318835cd",
  null
  
)

export default component.exports